/**
 * 統一ログシステム
 * 開発環境でのみデバッグログを表示し、本番環境では自動的に無効化
 */

const isDevelopment = process.env.NODE_ENV === 'development';
// デバッグログ出力フラグ（開発環境かつ明示的に有効化された場合のみ）
const isDebugEnabled = isDevelopment && process.env.REACT_APP_QUIZ_DEBUG === 'true';

/**
 * モジュール専用のロガーを作成
 * @param {string} moduleName - モジュール名（例: 'QuizPlayer', 'useQuizTimer'）
 * @returns {Object} ログ機能オブジェクト
 */
export const createLogger = (moduleName) => {
  const prefix = `[${moduleName}]`;
  
  return {
    /**
     * 情報ログ（開発環境のみ）
     * @param {string} message - ログメッセージ
     * @param {any} data - 追加データ（オプション）
     */
    info: (message, data = null) => {
      if (isDebugEnabled) {
        if (data !== null) {
          console.log(`${prefix} ${message}`, data);
        } else {
          console.log(`${prefix} ${message}`);
        }
      }
    },

    /**
     * 警告ログ（常に表示）
     * @param {string} message - ログメッセージ
     * @param {any} data - 追加データ（オプション）
     */
    warn: (message, data = null) => {
      if (data !== null) {
        console.warn(`${prefix} ${message}`, data);
      } else {
        console.warn(`${prefix} ${message}`);
      }
    },

    /**
     * エラーログ（常に表示）
     * @param {string} message - ログメッセージ
     * @param {any} data - 追加データ（オプション）
     */
    error: (message, data = null) => {
      if (data !== null) {
        console.error(`${prefix} ${message}`, data);
      } else {
        console.error(`${prefix} ${message}`);
      }
    },

    /**
     * デバッグログ（開発環境のみ、詳細情報用）
     * @param {string} message - ログメッセージ
     * @param {any} data - 追加データ（オプション）
     */
    debug: (message, data = null) => {
      if (isDebugEnabled) {
        if (data !== null) {
          console.log(`${prefix} [DEBUG] ${message}`, data);
        } else {
          console.log(`${prefix} [DEBUG] ${message}`);
        }
      }
    }
  };
};

/**
 * よく使用されるモジュール用の事前定義ロガー
 */
export const loggers = {
  quizPlayer: createLogger('QuizPlayer'),
  quizTimer: createLogger('QuizTimer'),
  quizCore: createLogger('QuizCore'),
  quizFirebase: createLogger('QuizFirebase'),
  quizValidation: createLogger('QuizValidation')
};

export default createLogger; 